
export default {
  props: ["cart","horizontal"],
};
